// Import { UsersLoginState, initialState as loginState } from "../login/_store";

export type UsersState = {
	// Login: UsersLoginState
};

export const initialState: UsersState = {
	login: {}, // LoginState
};
